//
//
// Local storage
//
//

export const getLocalStorageValue = (name, isJSON = true) => {
  const storageVal = window.localStorage.getItem(name)

  if (!storageVal) {
    return undefined
  }

  return !isJSON ? storageVal : JSON.parse(storageVal)
}

export const setLocalStorageValue = (name, data, isJSON = true) => {
  window.localStorage.setItem(name, isJSON ? JSON.stringify(data) : data)
}

//
//
// Session storage
//
//

export const getSessionStorageValue = (name, isJSON = true) => {
  const storageVal = window.sessionStorage.getItem(name)

  if (!storageVal) {
    return undefined
  }

  return !isJSON ? storageVal : JSON.parse(storageVal)
}

export const setSessionStorageValue = (name, data, isJSON = true) => {
  window.sessionStorage.setItem(name, isJSON ? JSON.stringify(data) : data)
}
